module.exports = __webpack_public_path__ + "static/home-ourproduct-crm-53b7805177b04648b035c73a9515d78e.png";